// extracted by mini-css-extract-plugin
module.exports = {"link":"choose-fp-modal_link__mwRht","group":"choose-fp-modal_group__vEjAy","percent":"choose-fp-modal_percent__8E3zD"};